module.exports = __webpack_public_path__ + "media/javascripts/apps/roku/assets/images/TVslide-2-22b4af9f50a2025929c7ec8f4df3b92a.png";